// Firebase Configuration for Push Notifications
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD6e5tKg_WEEpnJJFlWl2xjjqbP_uRE_hY",
  authDomain: "banaerp.firebaseapp.com",
  projectId: "banaerp",
  storageBucket: "banaerp.firebasestorage.app",
  messagingSenderId: "604333298263",
  appId: "1:604333298263:web:8bae7536fcad9f9e8cc912",
  measurementId: "G-2Q6WY4NTW9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser)
let analytics = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// Initialize Firebase Cloud Messaging
let messaging = null;
if (typeof window !== "undefined" && "Notification" in window) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.error("Firebase messaging initialization error:", error);
  }
}

// VAPID Key for web push (you'll need to generate this from Firebase Console)
// Go to Project Settings > Cloud Messaging > Web Push certificates
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

/**
 * Request permission and get FCM token
 * @returns {Promise<string|null>} FCM token or null if permission denied
 */
export const requestNotificationPermission = async () => {
  if (!messaging) {
    console.warn("Firebase messaging not initialized");
    return null;
  }

  try {
    // Request notification permission
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
      });

      console.log("FCM Token:", token);
      return token;
    } else {
      console.log("Notification permission denied");
      return null;
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
    return null;
  }
};

/**
 * Listen for foreground messages
 * @param {Function} callback - Function to call when message received
 * @returns {Function} Unsubscribe function
 */
export const onForegroundMessage = (callback) => {
  if (!messaging) {
    console.warn("Firebase messaging not initialized");
    return () => {};
  }

  return onMessage(messaging, (payload) => {
    console.log("Foreground message received:", payload);
    callback(payload);
  });
};

/**
 * Detect browser name from user agent
 */
const detectBrowserName = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('Opera') || ua.includes('OPR')) return 'Opera';
  return 'Unknown Browser';
};

/**
 * Detect platform from user agent
 */
const detectPlatform = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  return 'web';
};

/**
 * Generate device name
 */
const generateDeviceName = () => {
  const browser = detectBrowserName();
  const platform = navigator.platform || 'Unknown';
  return `${browser} on ${platform}`;
};

/**
 * Save FCM token to backend
 * @param {string} token - FCM token
 * @param {string} authToken - User auth token
 */
export const saveFCMTokenToBackend = async (token, authToken) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL || "";

  try {
    const response = await fetch(`${API_URL}/api/notifications/devices/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        fcm_token: token,
        platform: detectPlatform(),
        browser: detectBrowserName(),
        device_name: generateDeviceName(),
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to save FCM token");
    }

    console.log("FCM token registered with backend");
    return true;
  } catch (error) {
    console.error("Error saving FCM token:", error);
    return false;
  }
};

export { app, analytics, messaging };
